import { Typography, Modal, Checkbox, Row, Col, Divider } from 'antd';
import { useState, useEffect, useRef, useMemo } from 'react';
import {useLocalStorageListener,getUserDetail } from '../../../hooks/handleUserLocalStorage';

import moment from 'moment';
import { useGlobalVariable } from '../../../context/GlobalVariableProvider';
import ChangePasswordForm from '../../forms/change-password';
const { Title } = Typography;
interface Property {
    opened: boolean;
    children?: any;
    onClosed?: any;
    display?: any;
}

const ForceUpdatePasswordModal = (props: Property) => {
    // const [cookies, setCookie,removeCookie] = useCookies(['user']);
 
    const [title, setTitle] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const { setShowingForceChangePassword } = useGlobalVariable();

    // useEffect(() => {

    //     if (cookies.user) {
    //        // console.log("cookies.user",cookies.user)
    //        setIsModalOpen(cookies.user?.reset_password_mode);

    //     }
    // }, []);

    useLocalStorageListener((localdata) => {
        let localUser = getUserDetail();
        if (localUser) {
            if (localUser.user) {
                setIsModalOpen(localUser.user?.reset_password_mode);
            }
        }
    });

    useEffect(() => {
        setShowingForceChangePassword(isModalOpen);
        if (isModalOpen == true) {
          
        }
    }, [isModalOpen]);

    

    const handleCancel = () => {
        setIsModalOpen(false);
    };



    return (
        <>
            <Modal
                // bodyStyle={{
                //     overflowY: 'auto',
                //     minHeight: '70vh',
                //     maxHeight: '70vh',
                //     min
                //     maxWidth: '800px',
                //     // minWidth: '80vw'
                // }}
                title={title}
                open={isModalOpen}
                onCancel={handleCancel}
                closable={false}
                okButtonProps={{ style: { display: 'none' } }}
                maskClosable={false}
                footer={null}
            >
                <div style={{ position: 'relative', height: '100%',width:'100%',maxWidth:'800px' }}>
                    <Title level={3}>Change Password</Title>
                    <Divider />
                    <ChangePasswordForm  isForceChangePassword={true}/>
            
                </div>
            </Modal>

        </>
    );
};

export default ForceUpdatePasswordModal;
